<template>
    <swiper :options="swiperOptions">
      <swiper-slide>
        <el-image
        style="width: 1280px; height: 800px"
        src="https://erp-1256233047.cos.ap-shanghai.myqcloud.com/jsrsl.png"
        fit="fit">
        </el-image>
      </swiper-slide>
      <swiper-slide>
        <el-image
        style="width: 1280px; height: 800px"
        src="https://erp-1256233047.cos.ap-shanghai.myqcloud.com/bjrsl.png"
        fit="fit">
        </el-image>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  name: 'MyCompanyintroduction',
  data () {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        autoplay: true
      }
    }
  },
  mounted () {
  }
}
</script>

<style>
</style>
